<template>
  <a-modal
    v-model="visible"
    :title="$t('device_params_set_title')"
    :maskClosable="false"
    :closable="formLoading || checkLoading ? false : true"
    width="70%"
    :dialogStyle="{ minWidth: '900px' }"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    destroyOnClose
    centered
    :afterClose="close"
  >
    <Loading :show="true" v-if="loading" style="margin:50px auto;" />
    <div v-else>
      <a-upload
        :file-list="fileList"
        :remove="handleRemove"
        :before-upload="beforeUpload"
        style="margin:0 0 15px 0;display: block;"
        v-if="upload"
      >
        <div style="display:flex;align-items:center;">
          <a-button> <a-icon type="upload" /> {{ $t('com_upload_btn') }} </a-button>
          <p style="margin-left:10px;">
            {{ $t('com_upload_json_tip') }}
          </p>
        </div>
      </a-upload>

      <!-- 选择设备：只有设置一个参数时，才允许选择设备 -->
      <div class="device-box" v-if="deviceParams && deviceParams.length === 1">
        <!-- <div class="device-box-title">
          {{ $t('device_params_set_select_label') }}:
        </div> -->
        <div class="device-box-content device-config">
          <div class="device-selected-action">
            <a-button
              type="primary"
              icon="plus"
              @click="selectDeviceConfirm"
              style="margin-right:10px;"
            >
              {{ $t('device_params_set_select_add_device') }}
            </a-button>
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="willbeSelected"
              :placeholder="$t('device_form_select_device')"
              show-search
              allowClear
              style="width:300px;"
              :disabled="formLoading || checkLoading"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option
                :value="device.key"
                v-for="device in deviceList"
                :key="device.key"
                :disabled="device.disabled"
              >
                {{ device.name }}
              </a-select-option>
            </a-select>
            <p class="device-box-tips">
              {{ $t('device_control_remote_tip') }}
            </p>
          </div>

          <div class="device-selected">
            <a-tag
              :closable="item.active && !item.close ? true : false"
              :class="item.active ? '' : 'diabled'"
              @close="selectDeviceDelete(item.key)"
              v-for="item in deviceListSelected"
              :key="item.key"
            >
              <div>{{ item.name }}</div>
              <!-- 多个设备的时候才在设备上显示状态 -->
              <div class="g-refresh-status" v-if="isFinish && !isSingle">
                <Icon
                  type="status_ok"
                  class="success"
                  v-if="item.deviceItem && item.deviceItem.wflag === 1"
                />
                <Icon
                  type="status_error"
                  class="error"
                  v-if="item.deviceItem && item.deviceItem.wflag !== 1"
                />
              </div>
            </a-tag>
          </div>
        </div>
      </div>

      <div
        class="g-table params-preview"
        v-if="deviceParams && deviceParams.length > 0"
        :style="isSingle ? '' : 'padding:0'"
      >
        <a-form-model
          :model="form"
          :rules="rules"
          :initial-values="formInitialValues"
          ref="formElement"
          :label-col="{ span: 1 }"
          :wrapper-col="{ span: 23 }"
        >
          <a-table
            :columns="columns"
            :data-source="deviceParams"
            bordered
            :rowKey="(_text, index) => index"
            :pagination="false"
            rowStyle="color:#000000"
            :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
          >
            <!-- 名称 -->
            <template slot="Name" slot-scope="text">
              <span style="padding-left:17px;">{{ text }}</span>
            </template>

            <!-- 前一次的值 -->
            <template slot="PrevValue" slot-scope="text, record">
              <span v-if="text" style="padding-left:17px;">
                {{ itemTypes.calcTypeValue(record, text, 'rvalue') }}
                <span v-if="record.dataUnit">
                  {{ record.dataUnit }}
                </span>
              </span>
              <span v-else style="padding-left:17px;color:#ccc">--</span>
            </template>

            <!-- 当前值 -->
            <template slot="CurrentValue" slot-scope="text, record">
              <span v-if="text" style="padding-left:17px;">
                {{ itemTypes.calcTypeValue(record, text, 'rvalue') }}
                <span v-if="record.dataUnit">
                  {{ record.dataUnit }}
                </span>
              </span>
              <span v-else style="padding-left:17px;color:#ccc">--</span>
            </template>

            <!-- 编辑 -->
            <template slot="Edit" slot-scope="text, record">
              <div class="params-set-input">
                <!-- {{ record }} -->
                <ParamsItem
                  :record="record"
                  :itemValue.sync="form['row_' + record.id]"
                  :propName="'row_' + record.id"
                  :item="record"
                  :disabled="formLoading || checkLoading"
                  :form="form"
                />

                <!-- 成功的时候才显示状态，只有单个设备的时候才显示，多设备的时候在设备上显示状态 -->
                <div class="g-refresh-status" style="margin-top:-5px" v-if="isFinish && isSingle">
                  <Icon
                    type="status_ok"
                    class="success"
                    v-if="record.setAction && record.wflag === 1"
                  />
                  <Icon
                    type="status_error"
                    class="error"
                    v-if="record.setAction && record.wflag !== 1"
                  />
                </div>
              </div>
            </template>
          </a-table>
        </a-form-model>
      </div>

      <!-- 错误描述 -->
      <div class="form-error-text">
        <Icon type="error" v-if="formError" />
        <p>{{ formError }}</p>
      </div>
    </div>

    <template #footer>
      <div v-if="!loading">
        <a-button @click="close" style="margin-right:5px;" v-if="!(formLoading || checkLoading)">
          {{ $t('com_btn_cancel') }}
        </a-button>

        <!-- 成功时显示成功图标 -->
        <!-- <a-button @click="close" style="margin-right:5px;" v-if="isFinish">
          <span class="g-refresh-status" style="position:relative;top:3px;">
            <Icon type="status_ok" class="success" />
          </span>
          <span>
            {{ $t('com_btn_finish') }}
          </span>
        </a-button> -->

        <a-button
          type="primary"
          @click.prevent="checkSubmit"
          :loading="formLoading || checkLoading"
          :disabled="formLoading || checkLoading"
        >
          {{ $t('com_btn_set') }}
        </a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import * as API from '@/api/device';
import itemTypes from '@/libs/itemTypes';
import { trim } from '@/libs/utils';
import deviceAuth from '@/views/device/mixins/deviceAuth';

export default {
  mixins: [deviceAuth],
  props: {
    deviceInfo: {
      type: Object,
      default: () => {},
    },
    paramsList: {
      type: Array,
      default: () => [],
    },
    callback: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    form: {
      handler(_val) {
        this.formError = '';
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      itemTypes,

      // 新增
      visible: false,
      loading: true,

      willbeSelected: undefined,

      // 表单
      form: {},
      rules: {},
      formInitialValues: {
        row_262: '123',
      },

      formError: '',
      formType: '',
      formLoading: false,
      // 检查设备执行状态
      checkLoading: false,

      // params
      deviceParams: null,
      deviceAllParams: null,
      deviceAllParamsKey: [],
      deviceAllParamsOject: {},

      // 导入的无效的数据
      deviceParamsInvalid: [],

      columns: [
        {
          title: '#',
          align: 'center',
          width: 50,
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'Name' },
        },
        {
          title: this.$t('device_config_previous_value'),
          dataIndex: 'prevValue',
          scopedSlots: { customRender: 'PrevValue' },
        },

        {
          title: this.$t('device_table_current_value'),
          dataIndex: 'rvalue',
          scopedSlots: { customRender: 'CurrentValue' },
        },
        {
          title: this.$t('device_table_set_value'),
          dataIndex: 'Edit',
          scopedSlots: { customRender: 'Edit' },
        },
      ],

      // 同设备
      targetKeys: [],

      // 是否可导入
      upload: false,
      importLoading: false,
      fileList: [],
      uploading: false,

      deviceList: [],
      deviceListSelected: [],

      // 是否单个设备
      isSingle: false,

      // 是否结束
      isFinish: false,

      setTimer: null,
    };
  },
  beforeDestroy() {
    this.clearSetTimer();
  },
  methods: {
    //  - 显示
    show(params, upload) {
      this.visible = true;

      this.deviceParams = [];
      if (upload) {
        this.fileList = [];
        this.upload = upload;
        this.deviceAllParams = params;

        // 存储所有参数的对象
        this.deviceAllParams.forEach(item => {
          this.deviceAllParamsOject[item['dataSrc']] = item;
        });
        this.deviceAllParamsKey = (params || []).map(item => item.dataSrc);
      } else {
        this.deviceParams = params;
      }

      // 获取其他设备，只有参数为一个的时候，才允许多个设备一起设置
      if (this.deviceParams && this.deviceParams.length === 1) {
        this.getSameDeviceList();
      } else {
        this.loading = false;
        this.deviceListSelected.push({
          key: this.deviceInfo.devId,
          name: this.deviceInfo.name,
        });
      }

      this.setFormRules();
    },

    // 设置form验证
    setFormRules() {
      const rules = {};
      if (this.deviceParams && this.deviceParams.length) {
        this.deviceParams.forEach(record => {
          const itemName = 'row_' + record.id;
          // 验证方法
          const itemValidator = (rule, value, callback) => {
            if (trim(value)) {
              const currentItemType = this.itemTypes.array.find(
                typeItem => typeItem.value === record.dataType
              );
              if (currentItemType && currentItemType.inputValidator) {
                const isValidate = currentItemType.inputValidator(record, value);
                if (!isValidate) {
                  callback(new Error('error'));
                } else {
                  callback();
                }
              }
              callback();
            }
            callback();
          };

          // 全部不能为空
          rules[itemName] = [
            {
              required: true,
              message: this.$t('com_msg_not_be_empty'),
              trigger: 'blur',
            },
            {
              validator: itemValidator,
              message: this.$t('com_msg_not_ok'),
              trigger: 'blur',
            },
          ];

          // 设置默认值
          this.$set(this.form, 'row_' + record.id, record.rvalue);
        });
      }
      this.rules = rules;
    },

    // 禁用或开启已选设备的删除
    deviceListSelectedAction(close) {
      this.deviceListSelected.forEach(item => {
        item.close = close ? false : true;
      });
    },

    // 清除设置轮询
    clearSetTimer() {
      clearTimeout(this.setTimer);
    },

    // 重置
    reset() {
      this.clearSetTimer();
      this.formError = '';
      this.form = {};
      this.isFinish = false;
      this.formLoading = false;
      this.deviceListSelected = [];
      this.visible = false;
      this.upload = false;
      this.deviceParams = null;
    },

    close() {
      this.reset();
      // 如果是成功状态，刷新一次列表
      if (this.isFinish) {
        this.callback && this.callback();
      }
    },

    // 检查设备状态
    checkDeviceStatus() {
      const devIdList = this.deviceListSelected.map(item => item.key);
      const params = {
        devIds: devIdList.join(','),
      };
      this.checkLoading = true;
      this.formError = '';
      return API.DevicesStatusCheck(params)
        .then(res => {
          try {
            if (res.code === 0) {
              const data = res.data;
              // 是否全部设备空闲
              let hasBusy = false;
              data.some(item => {
                if (item.ctrlStatus !== 0) {
                  hasBusy = true;
                  return true;
                }
                return false;
              });

              if (hasBusy) {
                this.formError =
                  data.length > 1 ? this.$t('device_msg_some_busy') : this.$t('device_msg_busy');
                this.checkLoading = false;
                return false;
              }
              // 返回true可以下发set
              return true;
            } else {
              this.checkLoading = false;
              this.formError = res.message;
              this.deviceListSelectedAction(true);
              return false;
            }
          } catch (err) {
            console.log(err);
          }
        })
        .finally(() => {
          this.checkLoading = false;
        });
    },

    // 提交前检测
    checkSubmit() {
      // 表单检查，值不允许为空
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.checkDeviceStatus().then(status => {
            if (status) {
              this.addSubmit();
            }
          });
        }
      });
    },

    // 提交
    addSubmit() {
      const kvs = [];
      Object.keys(this.form).forEach(key => {
        const id = Number(key.split('_')[1]);
        const dataSrc = this.deviceParams.find(item => item.id === id).dataSrc;
        kvs.push({
          key: dataSrc,
          value: this.form[key],
        });
      });
      const devIdList = this.deviceListSelected.map(item => item.key);
      this.isSingle = devIdList && devIdList.length === 1;
      let params;
      if (this.isSingle) {
        params = {
          // 单个设备，可能单个或多个参数
          devId: devIdList[0],
          kvs,
        };
      } else {
        params = {
          // 多个设备，单个参数
          devIds: devIdList,
          kv: kvs[0],
        };
      }

      // 参数为空时，不允许提示
      if (!kvs.length) {
        this.formError = this.$t('com_msg_not_be_empty');
        return;
      }

      // 只有一个台设备时，如果值相同，不允许下发
      if (this.deviceParams.length === 1) {
        let hasSameValue = false;

        kvs.some(item => {
          if (hasSameValue) {
            return true;
          }
          this.deviceParams.some(param => {
            if (param.dataSrc == item.key && item.value == param.rvalue) {
              hasSameValue = true;
              return true;
            }
            return false;
          });
          return false;
        });
        if (hasSameValue) {
          this.formError = this.$t('device_msg_same_value_error');
          return;
        }
      }
      this.formLoading = true;

      // 禁用已选设备的删除
      this.deviceListSelectedAction(false);

      // 重新设置时
      this.isFinish = false;
      this.formError = '';
      if (this.isSingle) {
        // 单个设备
        API.DeviceParamsSet(params)
          .then(res => {
            if (res.code === 0) {
              const data = res.data;
              const self = this;
              // 单设备N参数设置;注意：成功时，其data数据为：0：pending(正在执行状态，则前端需要轮询查询)；1：finish(完成状态，则前端不需轮询只查询)，2表示超时(timeout)则可以结束轮询要么提示用户要么重试。其他为错误码
              if (data === 0 || data === 1) {
                // 延迟3秒再拿结果
                this.setTimer = setTimeout(function() {
                  self.getSingleDeviceStatus(params);
                }, 3 * 1000);
              } else {
                // 结束
                this.$message.warning(this.$t('device_msg_set_timeout'));
                this.formLoading = false;
                this.deviceListSelectedAction(true);
              }
            } else {
              this.formError = res.message;
              this.formLoading = false;
              this.deviceListSelectedAction(true);
            }
          })
          .catch(() => {
            this.formLoading = false;
            this.deviceListSelectedAction(true);
          });
      } else {
        // 多个设备
        API.DeviceParamsSets(params)
          .then(res => {
            if (res.code === 0) {
              const data = res.data;
              const self = this;
              if (data === 0 || data === 1) {
                // 延迟3秒再拿结果
                this.setTimer = setTimeout(function() {
                  self.getMultiDeviceStatus(params);
                }, 3 * 1000);
              } else {
                // 结束
                this.$message.warning(this.$t('device_msg_set_timeout'));
                this.formLoading = false;
                this.deviceListSelectedAction(true);
              }
            } else {
              this.formError = res.message;
              this.formLoading = false;
              this.deviceListSelectedAction(true);
            }
          })
          .catch(() => {
            this.formLoading = false;
            this.deviceListSelectedAction(true);
          });
      }
    },

    // set result action
    setResultAction(res, params) {
      this.clearSetTimer();

      // 配置
      const param = res.data.param;
      if (param) {
        const newParams = param.params;
        // 更新设置的参数列表，
        if (this.isSingle) {
          this.deviceParams.forEach(item => {
            const currentParams = newParams.find(param => param.key === item.dataSrc);
            if (currentParams) {
              item.wflag = currentParams.wflag;
              item.wvalue = currentParams.wvalue;
              item.rvalue = currentParams.rvalue;

              item.setAction = true;
            }
          });
        } else {
          // 多设备的时候，更新设备的状态即可(实际还是查询多设备各个参数的状态)
          param.forEach(item => {
            const devParams = item.params && item.params.length ? item.params[0] : null;

            // 循环设备
            if (devParams) {
              this.deviceListSelected.forEach(device => {
                if (device.key === devParams.devId) {
                  device.deviceItem = devParams;
                }
              });
            }
          });
        }
      }
      // 详细描述，用于获取设备最新的参数列表；注意：根据设备参数刷新状态判断, 0表示执行中(pending)，需要再次轮询获取结果；1表示完成(finish)，2表示超时(timeout)则可以结束轮询要么提示用户要么重试，返回参数最新数据;
      // 命令执行状态, 0表示执行中(pending)，需要再次轮询获取结果；1表示完成(finish), 2-超时，3-离线
      const setStatus = res.data.setStatus;
      // 是否轮询
      if (setStatus === 0) {
        const self = this;
        if (this.isSingle) {
          this.setTimer = setTimeout(function() {
            self.getSingleDeviceStatus(params);
          }, 2 * 1000);
        } else {
          this.setTimer = setTimeout(function() {
            self.getMultiDeviceStatus(params);
          }, 2 * 1000);
        }
      } else if (setStatus === 1) {
        this.isFinish = true;
        this.formLoading = false;
        this.deviceListSelectedAction(true);

        // 成功之后，主动刷新一次父列表的数据
        this.callback && this.callback();
      } else {
        // 2或3
        this.formLoading = false;
        this.formError = this.$t('device_msg_set_timeout');
        this.deviceListSelectedAction(true);
      }
    },

    // 获取单设备设置结果
    getSingleDeviceStatus(params) {
      const newParams = {
        devId: params?.devId || this.deviceListSelected[0].devId,
        keys: params?.kvs.map(item => item.key).join(','),
      };
      return API.DeviceParamsSetResult(newParams)
        .then(res => {
          if (res.code === 0) {
            this.setResultAction(res, params);
          } else {
            this.formError = res.message;
            // 如果报错，意味着结束
            this.isFinish = true;
          }
        })
        .finally(() => {
          this.formLoading = false;
        });
    },

    // 获取多设备设置结果
    getMultiDeviceStatus(params) {
      const newParams = {
        devIds: (params.devIds || []).join(','),
        key: params.kv.key,
      };
      return API.DeviceParamsSetsResult(newParams).then(res => {
        if (res.code === 0) {
          this.setResultAction(res, params);
        } else {
          this.formError = res.message;
          this.isFinish = true;
        }
      });
    },

    // 查询同类型的设备
    getSameDeviceList() {
      this.loading = true;
      const params = {
        devId: this.deviceInfo.devId,
      };
      return API.DeviceInSameSite(params)
        .then(res => {
          if (res.code === 0) {
            // 左边数据
            this.deviceList = [];
            // 筛选已经选择的设备
            this.deviceListSelected = [];
            res.data.forEach(item => {
              if (item.devId === this.deviceInfo.devId) {
                this.deviceListSelected.push({
                  key: item.devId,
                  name: item.name,
                  active: false,
                });
              } else {
                this.deviceList.push({
                  key: item.devId,
                  name: item.name,
                  active: true,
                });
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 读取文件
    async readData(files) {
      this.importLoading = true;
      const deviceParams = await new Promise((resolve, _reject) => {
        var vali = /\.(json)$/;
        if (!vali.test(files.name.toLowerCase())) {
          this.$message.error(this.$t('device_msg_import_file_error'));
          return false;
        }
        const fileReader = new FileReader();
        fileReader.onload = e => {
          try {
            const data = JSON.parse(e.target.result);
            // 滤过数据（参数里列表是否存在这个数据）
            const newData = [];

            data.forEach(item => {
              const dataSrc = item['key'];
              const value = item['rvalue'];
              if (this.deviceAllParamsKey.includes(item.key)) {
                const _temp = this.deviceAllParamsOject[dataSrc];
                _temp.defaultValue = value;

                if (item['id']) {
                  _temp.id = item['id'];
                }

                newData.push(_temp);
              }
            });

            resolve(newData);
            this.importLoading = false;
          } catch (e) {
            this.importLoading = false;
            return false;
          }
        };
        fileReader.readAsBinaryString(files);
      });

      console.log('deviceParams', deviceParams);
      console.log('form', this.form);

      // 列表数据
      this.deviceParams = deviceParams;

      // 设置验证规则
      this.setFormRules();
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;

      this.deviceParams = null;
    },
    beforeUpload(file) {
      // 只允许选择一个文件
      this.fileList = [file];

      this.readData(this.fileList[0]);
      return false;
    },

    selectDeviceConfirm() {
      this.formError = '';
      this.deviceList.some(item => {
        if (item.key === this.willbeSelected) {
          this.deviceListSelected.push(item);
          item.disabled = true;
          return true;
        }
        return false;
      });
      this.willbeSelected = undefined;
    },
    selectDeviceDelete(key) {
      this.formError = '';
      this.deviceListSelected.some((item, index) => {
        if (item.key === key) {
          this.deviceListSelected.splice(index, 1);
          return true;
        }
        return false;
      });
      this.deviceList.some(item => {
        if (item.key === key) {
          item.disabled = false;
          return true;
        }
        return false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.device-box {
  border-radius: 5px;
  margin-bottom: 10px;
  .device-box-title {
    font-size: 14px;
    font-weight: bold;
    border-bottom: #eee solid 1px;
  }
  .device-box-content {
    ::v-deep .device-selected {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .diabled {
        background: #ddd !important;
        border-color: #ddd !important;
      }

      .ant-tag {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding: 7px 10px;

        svg {
          margin: 0 0 0 5px;
        }
      }

      .anticon {
        color: #f00;
      }
    }

    .device-selected-action {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
    }

    .device-box-tips {
      color: #ec407a;
      padding: 10px 0 5px;
      margin: 0;
      margin-left: 10px;
    }
  }
}

::v-deep .params-preview {
  padding-top: 20px;
  .ant-table {
    .ant-table-content {
      overflow-x: auto;
      .ant-table-tbody {
        tr {
          td {
            padding: 5px 0;

            &:last-child {
              padding: 5px 15px;
            }
          }
        }
      }
    }
  }
}

.control-same-device {
  display: flex;
  padding: 10px 10px;
  align-items: center;
  background: #eee;
  margin: 20px 0;
  border-radius: 4px;
  color: #333;

  p {
    margin: 0;
  }
}

.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  padding-top: 20px;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

.params-set-input {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
